<template>
    <div class="main-contenttt">
        <MainKeyboard :main_element="current_component" />

        <div class="passcode-form-container animate__animated animate__fadeIn animate__delay-2s" v-if="typeof this.current_passcode == 'undefined' || this.current_passcode == null">
            <div class="passcode-form-overlay" @click="handleModalClick"></div>

            <div class="passcode-form-popup">
                <form action="" class="" @submit.stop.prevent>
                    <h3 class="page-subheading mb-1 animate__animated animate__fadeIn animate__delay-2s saveseat-username">Create a passcode to save this seat.</h3>
                    <div
                    class="
                        w-form-control w-input-fields
                        animate__animated animate__fadeInUp animate__delay-2s
                    "
                    >
                    <span><i class="fa-solid fa-lock"></i></span>
                    <input
                        type="password"
                        name="passpin"
                        value=""
                        v-model="passpin"
                        placeholder="Passcode" 
                        @focus="setFocusedElement($event, 'password', '')"
                    />
                    </div>
                    <div
                    class="
                        w-form-control w-input-fields
                        animate__animated animate__fadeInUp animate__delay-2s
                    "
                    >
                    <span><i class="fa-solid fa-lock"></i></span>
                    <input
                        type="password"
                        name="passpin_conf"
                        value=""
                        v-model="passpin_conf"
                        placeholder="Confirm Passcode" 
                        @keyup.enter="onPressPinEnter" 
                        @focus="setFocusedElement($event, 'password', '')"
                    />
                    </div>
                    <div class="main-action-box w-login-hide">
                        <div
                            class="
                            w-form-control
                            animate__animated animate__fadeInUp animate__delay-2s
                            "
                        >
                            <a
                            href="javascript:void(0)"
                            class="flex-fill" 
                            @click="handlePasscodeRequest"
                            >Done</a
                            >
                        </div>
                    </div>
                    <div class="w-login-show" style="width: 370px !important; text-align: center; margin: auto;">
                        <div class="notification-block p-1"></div>
                    </div>
                    <!-- start notification message section -->
                    <div
                    class="w-login-show animate__animated animate__fadeInUp move-to-header with-top"
                    v-if="popup_class !== '' && popup_message !== ''"
                    >
                        <div class="notification-block" :class="popup_class">
                            <div class="notification-message">
                            <h5>{{ popup_message }}</h5>
                            <p v-if="popup_message1 !== ''">{{ popup_message1 }}</p>
                            </div>
                            <div class="icon-success" v-if="popup_class == 'success'">
                            <i class="fa-solid fa-circle-check"></i>
                            </div>
                            <div class="icon-error" v-if="popup_class == 'error'">
                            <i class="fa-solid fa-times-circle"></i>
                            </div>
                            <div class="icon-warning" v-if="popup_class == 'warning'">
                            <i class="fa-solid fa-exclamation-circle"></i>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <template v-if="typeof this.current_passcode !== 'undefined' && this.current_passcode !== null">
            <h2 class="page-heading animate__animated animate__fadeIn animate__delay-1s saveseat-heading">Seat Saved!</h2>
            <h3 class="page-subheading mb-1 animate__animated animate__fadeIn animate__delay-1s saveseat-subheading">Return before timer expires<br>or you will be logged out.</h3>

            <!-- start timer section -->
            <div
                class="w-form-control timer animate__animated animate__fadeInUp animate__delay-2s timer_with_kb" 
            >
                <div class="timer-counter">{{ Math.ceil(seat_counter / 60000) }}</div>
                <div class="timer-unit">min</div>
            </div>
            <!-- end timer section -->

            <!-- start of login section -->
            <section class="login-page m-auto mt-4" style="width: 370px;">
                <form action="" class="" @submit.stop.prevent v-if="typeof this.current_passcode !== 'undefined' && this.current_passcode !== null">
                    <h3 class="page-subheading mb-1 animate__animated animate__fadeIn animate__delay-2s saveseat-username">{{username}}</h3>
                    <div
                    class="
                        w-form-control w-input-fields
                        animate__animated animate__fadeInUp animate__delay-2s
                    "
                    >
                    <span><i class="fa-solid fa-lock"></i></span>
                    <input
                        type="password"
                        name="password"
                        value=""
                        v-model="password"
                        placeholder="Passcode" 
                        @keyup.enter="onPressEnter" 
                        @focus="setFocusedElement($event, 'password', '')"
                    />
                    </div>
                    <div class="main-action-box w-login-hide">
                        <div
                            class="
                            w-form-control
                            animate__animated animate__fadeInUp animate__delay-2s
                            "
                        >
                            <a
                            href="javascript:void(0)"
                            class="flex-fill" 
                            @click="handleUnlockRequest"
                            >Unlock</a
                            >
                        </div>
                    </div>
                    <div class="w-login-show" style="width: 370px !important; text-align: center; margin: auto;">
                        <div class="notification-block p-1"></div>
                    </div>
                </form>
                <form action="" class="" @submit.stop.prevent v-else-if="typeof this.current_passcode == 'undefined' || this.current_passcode == null">
                    <h3 class="page-subheading mb-1 animate__animated animate__fadeIn animate__delay-2s saveseat-username">{{username}}</h3>
                    <div
                    class="
                        w-form-control w-input-fields
                        animate__animated animate__fadeInUp animate__delay-2s
                    "
                    >
                    <span><i class="fa-solid fa-lock"></i></span>
                    <input
                        type="password"
                        name="passpin"
                        value=""
                        v-model="passpin"
                        placeholder="pass code" 
                        @focus="setFocusedElement($event, 'password', '')"
                    />
                    </div>
                    <div
                    class="
                        w-form-control w-input-fields
                        animate__animated animate__fadeInUp animate__delay-2s
                    "
                    >
                    <span><i class="fa-solid fa-lock"></i></span>
                    <input
                        type="password"
                        name="passpin_conf"
                        value=""
                        v-model="passpin_conf"
                        placeholder="confirm pass code" 
                        @keyup.enter="onPressPinEnter" 
                        @focus="setFocusedElement($event, 'password', '')"
                    />
                    </div>
                    <div class="main-action-box w-login-hide">
                        <div
                            class="
                            w-form-control
                            animate__animated animate__fadeInUp animate__delay-2s
                            "
                        >
                            <a
                            href="javascript:void(0)"
                            class="flex-fill" 
                            @click="handlePasscodeRequest"
                            >Done</a
                            >
                        </div>
                    </div>
                    <div class="w-login-show" style="width: 370px !important; text-align: center; margin: auto;">
                        <div class="notification-block p-1"></div>
                    </div>
                </form>

                <!-- start notification message section -->
                <div
                class="w-login-show animate__animated animate__fadeInUp move-to-header with-top"
                v-if="noti_class !== '' && noti_message !== ''"
                >
                    <div class="notification-block" :class="noti_class">
                        <div class="notification-message">
                        <h5>{{ noti_message }}</h5>
                        <p v-if="noti_message1 !== ''">{{ noti_message1 }}</p>
                        </div>
                        <div class="icon-success" v-if="noti_class == 'success'">
                        <i class="fa-solid fa-circle-check"></i>
                        </div>
                        <div class="icon-error" v-if="noti_class == 'error'">
                        <i class="fa-solid fa-times-circle"></i>
                        </div>
                        <div class="icon-warning" v-if="noti_class == 'warning'">
                        <i class="fa-solid fa-exclamation-circle"></i>
                        </div>
                    </div>
                </div>
            </section>
            <!-- end of login section -->
        </template>
    
    </div>
</template>
  
<script>
import { ref } from "vue";
import { sessionActivitySave } from "../services/HomepageService";
import { global_config } from "@/config/config.js";
export default {
    name: "SaveSeatWidget-view",
    data() {
        return {
            seat_polling: null,
            username: "",
            password: "",
            user_data: null,
            messages: global_config.MESSAGES,
            seat_counter: 0,
            noti_class: '',
            noti_message: '',
            noti_message1: '',
            save_seat: false,
            save_seat_data: null,
            current_component: this,
            passpin: '',
            passpin_conf: '',
            current_passcode : ref(localStorage.getItem('passcode')),
            popup_class: '',
            popup_message: '',
            popup_message1: '',
        };
    },

    computed: {
    },

    methods: {
        setUserData() {
            this.user_data = JSON.parse(localStorage.user_sess_data);
            if(!Object.prototype.hasOwnProperty.call(this.user_data, 'role_id') || !Object.prototype.hasOwnProperty.call(this.user_data, 'email')) {
                this.$router.push("/");
            }
            this.username = this.user_data.email;
            // set item for tracking
            if(typeof localStorage.save_seat == 'undefined') {
                localStorage.setItem('save_seat', JSON.stringify({'active': 1, 'timer': process.env.VUE_APP_POLLING_SAVE_SEAT * 60 * 1000}));
            }
        },
        handleUnlockRequest() {
            if (this.password == "" || this.username == "")
                this.makeToast('generic-required-message', 'error');
            else {
                // let pod_data = JSON.parse(localStorage.pod_sess_data);
                // let session_id = pod_data.session_id_key;
                // userUnlock(session_id, this.username, this.password).then((response) => {
                //     if (response.status) {
                //         clearInterval(this.seat_polling);
                //         localStorage.removeItem('save_seat');
                //         this.$emit('initSaveSeat', false);
                //     } else {
                //         if(response.message == 'invalid') {
                //             this.makeToast('saveseat-invalid-error-message', 'error');
                //         }
                //         else {
                //             this.makeToast(response.message, 'error', response.message);
                //         }
                //     }
                // });

                if(this.current_passcode == this.password) {
                    clearInterval(this.seat_polling);
                    localStorage.removeItem('save_seat');
                    this.$emit('initSaveSeat', false);
                    localStorage.removeItem('passcode');
                }
                else {
                    this.makeToast('', 'error', 'Passcode is incorrect.');
                }
            }
        },
        onPressEnter() {
            this.handleUnlockRequest();
        },
        pollSaveSeat() {
            clearInterval(this.seat_polling);
            this.seat_counter = process.env.VUE_APP_POLLING_SAVE_SEAT * 60 * 1000;
            // check if local storage save seat is not empty
            this.save_seat = false;
            this.save_seat_data = null;          
            if(typeof localStorage.save_seat !== 'undefined') {
                this.save_seat = true;
                this.save_seat_data = JSON.parse(localStorage.getItem('save_seat'));
                this.seat_counter = this.save_seat_data.timer;
            }

            this.seat_polling = setInterval(() => {
                // check if code not set and no interaction for 10 seconds
                let last_activity = Math.floor((new Date()).getTime() - (new Date(localStorage.getItem('last_activity'))).getTime());
                if(last_activity >= 10000 && (typeof this.current_passcode == 'undefined' || this.current_passcode == null)) {
                    clearInterval(this.seat_polling);
                    localStorage.removeItem('save_seat');
                    this.$emit('initSaveSeat', false);
                    localStorage.removeItem('passcode');
                }
                else {
                    localStorage.setItem('last_activity', new Date());
                    this.seat_counter -= 15000;
                    // update local storage save seat
                    localStorage.setItem('save_seat', JSON.stringify({'active': 1, 'timer': this.seat_counter}));


                    if(this.seat_counter <= 0) {
                        clearInterval(this.seat_polling);
                        localStorage.removeItem('passcode');
                        this.$emit('handleLogout', {reason: 'Save seat expired', source: 'web'});   
                    }
                }
            }, 15000);
        },
        makeToast(message_key = '', variant = "default", message="", message1="", section='noti') {
            // search for key
            let smessage = this.$store.state.system_messages.list.find(o => o.msg_key === message_key);
            if(smessage !== null && typeof smessage !== 'undefined' && Object.prototype.hasOwnProperty.call(smessage, 'text_head')) {
                this[section + '_class'] = smessage.type == 'failure' ? 'error' : smessage.type;
                this[section + '_message'] = smessage.text_head;
                this[section + 'message1'] = smessage.text_sub;
            }
            else {
                this[section + '_class'] = variant;
                this[section + '_message'] = message;
                this[section + 'message1'] = message1;
            }
            // hide error div
            setTimeout(() => {
                this[section + '_class'] = "";
                this[section + '_message'] = "";
                this[section + 'message1'] = "";
            }, 5000);
        },
        setFocusedElement(event, ref, form) {
            this.$store.commit("setFocusedElement", ref);
            this.$store.commit("setFocusedElementForm", {'form': form, 'target' : event});
        },
        onPressPinEnter() {
            this.handlePasscodeRequest();
        },
        handlePasscodeRequest() {
            if (this.passpin == "" || this.passpin_conf == "") {
                this.makeToast('generic-required-message', 'error', '', '', 'popup');
            }
            else if(this.passpin !== this.passpin_conf) {
                this.makeToast('', 'error', 'The two passcodes entered do not match.', '', 'popup');
            }
            else {
                localStorage.setItem('passcode', this.passpin);
                this.current_passcode = this.passpin;
                this.passpin = '';
                this.passpin_conf = '';
            }
        },
        handleModalClick() {
            clearInterval(this.seat_polling);
            localStorage.removeItem('save_seat');
            this.$emit('initSaveSeat', false);
            localStorage.removeItem('passcode');
        },
    },

    mounted() {
        this.pollSaveSeat();
        // call activity record api
        sessionActivitySave({'activity': global_config.ACTIVITIES.PLAY_SAVE}).then((response) => {
            response;
        });

        // Sync localStorage to reactive ref when changed outside (optional advanced)
        window.addEventListener('storage', (event) => {
            console.log("STORAGE EVENT IS : ", event);
            if (event.key === 'passcode') {
                this.current_passcode = event.newValue;
            }
        });
    },
    beforeDestroy () {
        clearInterval(this.seat_polling);
    },
    created () {
        this.setUserData();
    }
};
</script>
<style scoped>
    .main-layout-section .main-content {
        width: 100%;
        min-height: 67.5vh;
    }
    div.timer {
        position: relative;
        margin: auto;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
        /* overflow: hidden; */
        color: #d8d8d8;
        border-radius: 50%;
        font-weight: 700;
        font-family: 'Open Sans';
        animation: 60s 0.875s cubic-bezier(0.9, 0, 0.1);
    }

    div.timer_with_kb {
        width: 150px;
        height: 150px;
        font-size: 70px;
        border: 2px solid var(--client-primary);
        margin-top: 25px;
    }

    @keyframes timer_beat {
        40%,
        80% {
            transform: none; }
        50% {
            transform: scale(1.125);
        }
    }
    div.timer:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: -100;
        width: 100%;
        height: 100%;
        animation: 60s 1s linear forwards timer_indicator;
    }

    @keyframes timer_indicator {
        100% {
            transform: translateY(100%);
        }
    }
    .saveseat-username {
        font-size: 20px;
        font-family: 'Open Sans';
        padding-bottom: 10px;
    }
    .saveseat-heading {
        font-size: 30px;
        font-family: 'Open Sans';
        font-weight: 600;
    }
    .saveseat-subheading {
        font-size: 16px;
        font-weight: normal;
        font-family: 'Open Sans';
    }
    .timer-unit {
        position: absolute;
        left: 130px;
        font-size: 14px;
        bottom: 0px;
        font-family: 'Open Sans';
    }
    .passcode-form-container {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 10;
        top: 0;
        bottom: 0;
    }
    .passcode-form-overlay {
        background: black;
        width: 100%;
        height: 100%;
        opacity: 0.8;
        position: absolute;
        top: 0;
        bottom: 0;
    }
    .passcode-form-popup {
        width: 380px;
        height: 100%;
        margin: auto;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .passcode-form-popup > form {
        display: block;
        background: linear-gradient(30deg, var(--client-gradiant), var(--client-accent));
        background-image: linear-gradient(30deg, var(--client-gradiant), var(--client-accent));
        width: 100%;
        height: fit-content;
        padding: 15px;
        border-radius: 8px;
    }
</style>